import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import BASE_URL from "../config";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SalesPerson = (props) => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [pageComponent, setPageComponent] = useState("salespersons");
  const [data, setData] = useState(undefined);
  const [code, setCode] = useState("");
  const [pName, setpName] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyCode, setEmptyCode] = useState(false);
  const [emptyDesc, setEmptyDesc] = useState(false);
  let [duplicateVal, setDuplicateVal] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setCode("");
    setpName("");
    setDuplicateVal(false);
  };

  function setSelectedRow(rowid) {
    axios
      .get(`${BASE_URL}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        setSelectRowData(selectRowData);
        setCode(
          selectRowData.salespersons.sales_person_code
            ? selectRowData.salespersons.sales_person_code
            : ""
        );

        setpName(
          selectRowData.salespersons.sales_person_name
            ? selectRowData.salespersons.sales_person_name
            : ""
        );
        setBtnActive(false);
      });
  }

  const handleSave = (event) => {
    event.preventDefault();
    setEmptyInput(false);
    const inputData = { sales_person_code: code, sales_person_name: pName };
    const duplicate = data.some((el) => el.SPCode === code);

    if (code.length === 0) {
      toast.error("Sales Person Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCode(true);
      setEmptyInput(true);
    } else {
      setEmptyCode(false);
    }

    if (pName.length === 0) {
      toast.error("Sales Person description can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyDesc(false);
    }

    if (emptyInput !== true) {
      if (duplicate !== true) {
        axios
          .post(`${BASE_URL}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            setCode("");
            setpName("");
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This Sales Person code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = { sales_person_code: code, sales_person_name: pName };
      setEmptyInput(false);

      if (pName.length === 0) {
        toast.error("Vessel Code can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setEmptyDesc(true);
        setEmptyInput(true);
      } else {
        setEmptyDesc(false);
      }

      if (emptyInput !== true) {
        axios
          .post(
            `${BASE_URL}${pageComponent}/update/${selectRowData.salespersons.id}`,
            inputData,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${authtoken}`,
              },
            }
          )
          .then((response) => {
            setCode("");
            setpName("");
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setTimeout(window.location.reload.bind(window.location), 2000);
      }
    }
  };

  useEffect(() => {
    fetch(`${BASE_URL}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.salespersons);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken, pageComponent]);

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${BASE_URL}${pageComponent}/destroy/${selectRowData.salespersons.id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = ["Sales Person Code", "Sales Person Name"];
  const columns = ["sales_person_code", "sales_person_name"];

  const handleButtonClickPDF = () => {
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(columns) || columns.length === 0) {
      // Handle the scenario where the data or selected keys are invalid or empty
      toast.error("Invalid data or selected keys for export.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const filteredRows = data.map(obj => {
      const filteredRow = {};
      columns.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          filteredRow[key] = obj[key];
        }
      });
      return filteredRow;
    });

    const doc = new jsPDF();
    const rows = filteredRows.map(obj => Object.values(obj));

    const columnStyles = {}; // Object to hold column styles

    // Set cell widths (adjust widths as needed)
    columns.forEach(key => {
      columnStyles[key] = { cellWidth: 30 }; // Change width as per your requirement
    });

    doc.autoTable({
      columns: tTitle.map(key => ({ header: key, dataKey: key })),
      body: rows,
      columnStyles,
      startY: 5, // Adjust the starting Y position for the table
      // ... other configuration options
    });

    // Save the PDF file
    const dateTime = new Date().toISOString().replace(/[-T:.Z]/g, '');
    const fileName = `Sales Person_PDF_Report_${dateTime}.pdf`;
    doc.save(fileName);
  };

  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Sales Person Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="SP. Code"
                    name="code"
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyCode === true ? "border-red2" : ""}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Sales Person Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="SP. Name"
                    name="pname"
                    value={pName}
                    className={emptyDesc === true ? "border-red2" : ""}
                    onChange={(e) => setpName(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center"></Row>{" "}
            <Col className="text-end">
              {props.selectedAuthority && props.selectedAuthority.new === 1 ? (
                <>
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={selectRowData !== "" ? edditRow : handleSave}
                    disabled={btnActive}
                  >
                    Save
                  </Button>


                  <Button className="ms-3" variant="primary" onClick={createNewRow}>
                    New
                  </Button>
                </>
              ) : null}

              {props.selectedAuthority && props.selectedAuthority.edit === 1 ? (
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
              ) : null}

              {props.selectedAuthority && props.selectedAuthority.delete === 1 ? (
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>
              ) : null}

              {props.selectedAuthority && props.selectedAuthority.print === 1 ? (
                <Button className="ms-3" variant="primary" onClick={handleButtonClickPDF}>
                  Print
                </Button>
              ) : null}

              {/* <Button className="ms-3" variant="primary" type="submit">
                Cancel
              </Button> */}
            </Col>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SalesPerson;
